<template>
  <v-layout fluid fill-height>
    <v-data-table
      :headers="headers"
      :items="logs"
      :loading="loading"
      :options.sync="pagination"
      :page.sync="currentPage"
      :server-items-length="totalItems"
      :items-per-page="10"
      :footer-props="{
        itemsPerPageOptions: [10, 50, 100], 
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-less-than',
        nextIcon: 'mdi-greater-than',
        itemsPerPageText: $t('label.rowPerPage')
      }"
      :no-data-text="$t('label.nodata')"
      show-expand
      item-key="pos"
      class="elevation-1 table-fluid idcs-pane-back px-4"
      :sort-by="'dt'"
      :sort-desc="false"
    >
      <template v-slot:progress>
        <div class="progress-container">
          <v-progress-circular :size="100" :width="7" color="green" indeterminate></v-progress-circular>
        </div>
      </template>
      <template v-slot:top>
        <v-layout fluid class="align-center">
          <v-flex md4>
            <v-btn :disabled="logs.length==0" icon @click="d_print=true">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
            <date-picker
              v-model="sd"
              range
              confirm
              clearable
              @confirm="newRange"
              :shortcuts="shortcuts"
              :lang="$i18n.locale"
              :disabled="!dataOn"
              :input-class="dataOn?'idcs-data-pick':'idcs-data-pick-off'"
              class="idcs-picker-wrap"
            ></date-picker>
            <v-btn icon @click="dataOn=!dataOn" :color="dataOn?'green':'red'">
              <v-icon>mdi-calendar-check-outline</v-icon>
              <!--            <v-icon>{{dataOn?'mdi-calendar-check-outline':'mdi-calendar-blank-outline'}}</v-icon>!-->
            </v-btn>
          </v-flex>
          <v-flex md3></v-flex>
          <v-flex md4>
            <v-text-field
              :placeholder="$t('search.pattern')"
              dense
              background-color="yellow lighten-5"
              color="black"
              shaped
              outlined
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              clearable
              :disabled="filterPane"
              v-model.trim="search"
              @click:prepend-inner="applySearch"
              @keyup.enter="applySearch"
              @keyup.escape="resetSearch"
              @click:clear="resetSearch"
              class="search-str pt-6"
            ></v-text-field>
          </v-flex>
          <v-flex md1 class="text-right">
            <v-btn
              v-show="filterActive && !filterPane"
              icon
              @click="resetFilter"
              color="error"
              class="f-btn-1"
            >
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
            <v-btn
              icon
              @click="filterPane=!filterPane"
              :class="'f-btn-2-'+(filterActive && !filterPane)"
            >
              <v-icon
                v-text="(!filterPane?'mdi-filter-menu':'mdi-filter')+(!filterActive?'-outline':'')"
              ></v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-scroll-y-transition :appear="true">
          <v-layout
            v-show="filterPane"
            wrap
            class="mb-4 idcs-dialog-back filter-pane"
            justify-space-around
          >
            <v-flex xl2 lg2 md4 sm11 xs11 class="mt-6">
              <v-text-field
                v-model.trim="filters.REQ_TERMINAL"
                outlined
                shaped
                dense
                clearable
                @keypress.enter="applyFilter"
                :background-color="filters.REQ_TERMINAL?'yellow lighten-5':''"
                :label="$t('field.terminal')"
              ></v-text-field>
            </v-flex>
            <v-flex xl2 lg2 md3 sm11 xs11 class="mt-md-6">
              <v-text-field
                v-model.trim="filters.REQ_MS"
                outlined
                shaped
                dense
                clearable
                @keypress.enter="applyFilter"
                :background-color="filters.REQ_MS?'yellow lighten-5':''"
                :label="$t('field.card')"
              ></v-text-field>
            </v-flex>
            <v-flex xl2 lg2 md3 sm11 xs11 class="mt-md-6">
              <v-text-field
                v-model.trim="filters.ip"
                outlined
                shaped
                dense
                clearable
                @keypress.enter="applyFilter"
                :background-color="filters.ip?'yellow lighten-5':''"
                :label="$t('field.ip')"
              ></v-text-field>
            </v-flex>
            <v-flex xl1 lg1 md3 sm11 xs11 class="mt-lg-6">
              <v-text-field
                v-model.trim="filters.REQ_COMMAND"
                outlined
                shaped
                dense
                clearable
                @keypress.enter="applyFilter"
                :background-color="filters.REQ_COMMAND?'yellow lighten-5':''"
                :label="$t('field.req_command')"
              ></v-text-field>
            </v-flex>
            <v-flex xl1 lg1 md3 sm11 xs11 class="mt-lg-6">
              <v-text-field
                v-model.trim="filters.RESP_CODE"
                outlined
                shaped
                dense
                clearable
                @keypress.enter="applyFilter"
                :background-color="filters.RESP_CODE?'yellow lighten-5':''"
                :label="$t('field.code')"
              ></v-text-field>
            </v-flex>
            <v-flex xl3 lg3 md3 sm11 xs11 align-center justify-end d-flex class="mt-md-n6 mt-lg-0 mb-sm-4 mb-xs-4">
              <v-btn rounded @click="applyFilter" small color="accent" class="white--text mr-2">
                <v-icon>mdi-check</v-icon>
                {{$t("button.apply")}}
              </v-btn>
              <v-btn small :disabled="!filterActive" rounded @click="resetFilter" color="error">
                <v-icon>mdi-close</v-icon>
                {{$t("button.reset")}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-scroll-y-transition>
        <v-divider></v-divider>
      </template>
      <template v-slot:item="{headers, item, isExpanded, expand}">
        <tr :class="(item.pos%2==0?'idcs-data-back':'idcs-data-back2')">
          <template v-for="h in headers">
            <td v-if="h.value=='dt'" :key="h.value">{{item.dt | dt-sec}}</td>
            <td v-else-if="h.value=='data-table-expand'" :key="h.value">
              <v-btn
                x-small
                icon
                @click="expand(!isExpanded)"
                :color="!isExpanded?'blue lighten-2':'blue lighten-4'"
              >
                <v-icon>{{isExpanded?'fa-angle-double-up':'fa-angle-double-down'}}</v-icon>
              </v-btn>
            </td>
            <td v-else :key="h.value" :align="h.align">{{item[h.value]}}</td>
          </template>
        </tr>
      </template>
      <template v-slot:item.DT="{item}">{{item.DT | dt-sec}}</template>
      <template v-slot:expanded-item="{ item, headers }">
        <td :colspan="headers.length" class="detail-row">
          <v-layout row wrap class="py-2">
            <div v-for="i in details" :key="i.text">
              <v-flex
                v-if="item[i.value]!=null && item[i.value]!='' && item[i.value]!='0'"
                class="ma-2 pa-2 detail-main"
              >
                <div class="detail-header">
                  {{i.text}}
                  <v-btn v-if="item[i.value].length>40" icon @click="showData(item[i.value])">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </div>

                <div
                  class="detail-value"
                  :title="item[i.value]"
                >{{i.filter ? $options.filters[i.filter](item[i.value]) : item[i.value]}}</div>
              </v-flex>
            </div>
          </v-layout>
        </td>
      </template>
      <template v-slot:body.append="{headers}">
        <tr>
          <td :colspan="headers.length" class="detail-row">
            <v-subheader>{{$t('label.modified')+': '+ lastUpdate.format("H:mm:ss")}}</v-subheader>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog
      v-model="showDataDialog"
      scrollable
      hide-overlay
      transition="scroll-y-transition"
      width="380px"
    >
      <v-card>
        <v-card-text>
          <div v-html="dataDialogMessage" class="dialog-content"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <PrintDialog v-model="d_print" :items="details" @click:ok="printPage" />
  </v-layout>
</template>

<script>
//import axios from "axios";
import app from "@/app.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/lv.js";
import "vue2-datepicker/locale/ru.js";
import moment from "moment";
import PrintDialog from "@/components/PrintDialog";

export default {
  components: { DatePicker, PrintDialog },
  data() {
    return {
      d_print: false,
      showDataDialog: false,
      dataDialogMessage: "",
      dataOn: 1,
      command: 0,
      commands: [
        { text: "Terminal settings", value: 900 },
        { text: "Report", value: 1000 },
        { text: "Info", value: 1100 },
        { text: "Transaction", value: 1200 },
        { text: "Reversal", value: 1300 }
      ],
      filterPane: false,
      filterActive: false,
      search: "",
      sd: [new Date(), new Date()],
      shortcuts: [
        {
          text: this.$t("picker.today"),
          onClick() {
            return [new Date(), new Date()];
          }
        },
        {
          text: this.$t("picker.yesterday"),
          onClick() {
            const f = moment()
              .subtract(1, "day")
              .startOf("day")
              .toDate();
            const e = moment()
              .subtract(1, "day")
              .endOf("day")
              .toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.currentWeek"),
          onClick() {
            const f = moment()
              .startOf("week").isoWeekday(1)
              .toDate();
            const e = moment().toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.previousWeek"),
          onClick() {
            const f = moment()
              .subtract(1, "week")
              .startOf("week").isoWeekday(1)
              .toDate();
            const e = moment()
              .subtract(1, "week")
              .endOf("week")
              .toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.currentMonth"),
          onClick() {
            const f = moment()
              .startOf("month")
              .toDate();
            const e = moment().toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.previousMonth"),
          onClick() {
            const f = moment()
              .subtract(1, "months")
              .startOf("month")
              .toDate();
            const e = moment()
              .subtract(1, "months")
              .endOf("month")
              .toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.fromPreviousMonth"),
          onClick() {
            const f = moment()
              .subtract(1, "months")
              .startOf("month")
              .toDate();
            const e = moment().toDate();
            return [f, e];
          }
        },
        {
          text: this.$t("picker.fromStartYear"),
          onClick() {
            const f = moment()
              .startOf("year")
              .toDate();
            const e = moment().toDate();
            return [f, e];
          }
        }
      ],
      filters: {
        REQ_TERMINAL: "",
        REQ_MS: "",
        RESP_CODE: "",
        REQ_COMMAND: "",
        ip: ""
      },
      lastUpdate: this.$moment(),
      expanded: [],
      currentPage: 1,
      loading: false,
      //      cards: [],
      totalItems: 0,
      pagination: {},
      logs: [],
      details: [
        { text: this.$t("field.resp1"), value: "RESP_PAR1" },
        { text: this.$t("field.resp2"), value: "RESP_PAR2" },
        { text: this.$t("field.resp3"), value: "RESP_PAR3" },
        { text: this.$t("field.resp4"), value: "RESP_PAR4" },
        { text: this.$t("field.resp5"), value: "RESP_PAR5" },
        { text: this.$t("field.resp6"), value: "RESP_PAR6" },
        { text: this.$t("field.resp7"), value: "RESP_PAR7" },
        { text: this.$t("field.resp8"), value: "RESP_PAR8" },
        { text: this.$t("field.resp9"), value: "RESP_PAR9" },
        { text: this.$t("field.receipt"), value: "RESP_RECEIPT_NR" },
        { text: this.$t("field.pin"), value: "RESP_PIN" },
        { text: this.$t("field.resp_dt"), value: "RESP_DT" },
        { text: this.$t("field.flags"), value: "RESP_FLAGS" },
        { text: this.$t("field.resp_id"), value: "RESP_REQUEST_ID" },
        { text: this.$t("field.req_id"), value: "REQ_REQUEST_ID" },
        { text: this.$t("field.lang"), value: "REQ_LANG" },
        { text: this.$t("field.type"), value: "TYPE" },
        { text: this.$t("field.ip"), value: "IP" },
        { text: this.$t("field.req_dt"), value: "REQ_DT" },
        { text: this.$t("field.additional"), value: "REQ_ADDITIONAL" }
      ],
      headers: [
        { text: "#", align: "center", value: "pos", sortable: false },
        {
          text: this.$t("field.dt"),
          align: "left",
          value: "DT",
          filter: "dt-sec",
          sortable: true
        },
        {
          text: this.$t("field.req_command"),
          align: "right",
          value: "REQ_COMMAND",
          sortable: true
        },
        { text: this.$t("field.req_ms"), align: "left", value: "REQ_MS", sortable: true },
        { text: this.$t("field.req_terminal"), value: "REQ_TERMINAL", sortable: true },
        {
          text: this.$t("field.operation"),
          value: "REQ_PAR3",
          sortable: false
        },
        { text: this.$t("field.par1"), align: "right", value: "REQ_PAR1", sortable: true },
        { text: this.$t("field.par2"), align: "right", value: "REQ_PAR2", sortable: true },
        { text: this.$t("field.code"), value: "RESP_CODE", sortable: true },
        { text: this.$t("field.message"), value: "MESSAGE", sortable: false },
        { text: "", value: "data-table-expand" }
      ]
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true
    },
    sd: {
      handler() {
        if (this.filterPane) return;
        this.currentPage = 1;
        this.getDataFromApi();
      },
      deep: true
    }
  },
  mounted() {
    //this.loadData(this.$moment(new Date()).format("YYYYMMDD"));
  },
  computed: {},
  methods: {
    showData(d) {
      if (d.indexOf("<") != -1) {
        d = String(d)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
        this.dataDialogMessage = d;
      } else {
        let m = "<div>";
        while (d.length > 0) {
          m += "<p>" + d.substring(0, 42) + "</p>";
          d = d.substring(42);
        }
        console.log(m);
        this.dataDialogMessage = m + "</div>";
      }
      this.showDataDialog = true;
    },
    printPage() {
      this.loadData(true).then(response => {
        this.loading = false;
        let headers = {
          title: this.$t("report.title.logs"),
          created: new Date().toString(),
          search: this.search,
          filter: this.filters,
          sd: this.$options.filters["dt-time"](this.sd[0]),
          ed: this.$options.filters["dt-time"](this.sd[1])
        };
        let footers = { totals: {} };
        let head = this.headers.slice();
        this.details.forEach(e => {
          if (e.prn) {
            head.push(e);
          }
        });
        app.generatePrintPage(response, head, headers, footers);
      });
    },
    resetSearch() {
      for (let k in this.filters) {
        this.filters[k] = "";
      }
      this.search = "";
      this.filterPane = false;
      this.filterActive = false;
      this.currentPage = 1;
      this.getDataFromApi();
    },
    applySearch() {
      for (let k in this.filters) {
        this.filters[k] = "";
      }
      this.filterActive = false;
      this.currentPage = 1;
      this.getDataFromApi();
    },
    applyFilter() {
      this.search = "";
      this.filterActive = true;
      this.currentPage = 1;
      this.getDataFromApi();
    },
    resetFilter() {
      this.resetSearch();
    },
    newRange() {
      if (this.filterPane) return;
      this.currentPage = 1;
      this.getDataFromApi();
    },
    getDataFromApi() {
      while (this.logs.length > 0) {
        this.logs.pop();
      }
      this.loadData().then(response => {
        this.logs = response.items;
        this.totalItems = response.count;
        this.lastUpdate = this.$moment();
        this.loading = false;
      });
    },
    loadData(unlimit) {
      this.loading = true;
      let sort = "";
      if (this.pagination.sortBy.length) {
        sort = this.pagination.sortBy[0];
      }
      if (this.pagination.sortDesc.length) {
        sort += this.pagination.sortDesc[0] ? " desc" : " asc";
      }
      if (this.search == null) this.search = "";
      const params = {
        pattern: this.search,
        filter: this.filters,
        limit: unlimit ? -1 : this.pagination.itemsPerPage,
        offset: (this.pagination.page - 1) * this.pagination.itemsPerPage,
        order: sort
      };
      if (this.dataOn) {
        if (this.sd[0] == null) this.sd[0] = new Date();
        if (this.sd[1] == null) this.sd[1] = new Date();
        params.sd = this.$moment(this.sd[0]).format("YYYYMMDD");
        params.ed = this.$moment(this.sd[1]).format("YYYYMMDD");
      }
      return app.loadLogs(params);
    }
  }
};
</script>
<style lang="scss" scoped>
.progress-container {
  width: 100%;
  text-align: center;
  padding: 20px;
}
/*.main-toolbar {
  padding-top: 8px;
}*/
.f-btn-2-false {
  /*  height: 40px !important;
  width: 40px !important;*/
  border-radius: 25px 25px 25px 25px;
  background-color: rgb(232, 245, 233);
  /*margin-right: -10px !important;*/
}
.f-btn-2-true {
  /*  height: 40px !important;
  width: 40px !important;*/
  border-radius: 0 25px 25px 0;
  background-color: rgb(232, 245, 233);
  /*margin-right: -10px !important;*/
}
.f-btn-1 {
  /*  height: 40px !important;
  width: 40px !important;*/
  border-radius: 25px 0 0 25px;
  background-color: antiquewhite;
  /*margin-right: -10px !important;*/
}
.table-fluid {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.filter-pane {
  border-radius: 25px;
}
.detail-main {
  text-align: center;
}
.detail-row {
  background-color: ghostwhite;
}
.row-expanded-true {
  background-color: ghostwhite;
}
.detail-header {
  text-align: center;
  font-size: x-small;
}
.detail-value {
  text-align: center;
  font-weight: bold;
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
/*.mx-shortcuts-wrapper {
  float: left;
  width: 80px;
  border-bottom: 0;
}*/
.dialog-content {
  font-family: monospace;
}
.detail-row {
  background-color: ghostwhite;
}
</style>